import React, { useState, useEffect, useRef} from "react";
import { BRAND, contrastText, getThemeColors, inputStyle } from "./themes";
import { API_BASE_URL } from "./config";
import { useNavigate } from "react-router-dom";



function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return isMobile;
}

export default function CustomScenarioPage({ onBack, onSubmit, theme, setTheme }) {
  const isMobile = useIsMobile();
  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
  (async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/auth/me`, {
        method: "GET",
        credentials: "include",
      });

      if (res.status === 401) {
        navigate("/login", { replace: true });
        return;
      }

      const data = await res.json();
      setUsername(data.username || null);
    } catch (e) {
      // optional: treat network errors as logged-out
      navigate("/login", { replace: true });
    } finally {
      setLoading(false);
    }
  })();
  }, [navigate]);


  
  const ThemeToggle = () => (
    <div 
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      style={{
        width: 60,
        height: 30,
        borderRadius: 15,
        background: theme === 'dark' ? '#2c3e50' : '#f39c12',
        position: 'relative',
        cursor: 'pointer',
        transition: 'background 0.3s ease',
        border: '2px solid rgba(255,255,255,0.2)'
      }}
    >
      <div style={{
        position: 'absolute',
        top: 3,
        left: theme === 'dark' ? 3 : 31,
        width: 20,
        height: 20,
        borderRadius: '50%',
        background: '#fff',
        transition: 'left 0.3s ease',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12
      }}>
        {theme === 'dark' ? '🌙' : '☀️'}
      </div>
    </div>
  );
  const [formData, setFormData] = useState({
    // Persona Details
    name: "",
    position: "",
    team_name: "",
    team_size: "",
    overview: "",
    openness: 2,
    conscientiousness: 2,
    extraversion: 2,
    agreeableness: 2,
    regulation: 2,
    behavioral_overview: "",
    initial_reaction: "",
    tendency: "",
    emotional_regulation: "",
    // Scenario Details
    scenario_name: "",
    industry: "",
    company_type: "",
    manager_role: "",
    feedback_goals: "",
    recent_performance: "",
    recent_events: "",
    work_characteristics: "",
    key_event: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const customScenario = {
      background: {
        name: formData.name,
        position: formData.position,
        overview: formData.overview,
        big_five_personality_breakdown: {
          openness: { level: ["high", "moderate", "low"][formData.openness], facets: {} },
          conscientiousness: { level: ["high", "moderate", "low"][formData.conscientiousness], facets: {} },
          extraversion: { level: ["high", "moderate", "low"][formData.extraversion], facets: {} },
          agreeableness: { level: ["high", "moderate", "low"][formData.agreeableness], facets: {} },
          regulation: { level: ["high", "moderate", "low"][formData.regulation], facets: {} }
        },
        behavioral_feedback_response_profile: {
          overview: formData.behavioral_overview,
          initial_reaction: formData.initial_reaction,
          tendency: formData.tendency,
          emotional_regulation: formData.emotional_regulation
        }
      },
      scenario: {
        scenario_num: "custom",
        scenario_name: formData.scenario_name,
        Persona: formData.name,
        industry: formData.industry,
        company_type: formData.company_type,
        team_name: formData.team_name,
        team_composition: formData.team_size,
        manager_role: formData.manager_role,
        recent_performance: formData.recent_performance.split('\n').map(s => s.trim()).filter(Boolean),
        recent_events_and_metrics: formData.recent_events.split('\n').map(s => s.trim()).filter(Boolean),
        further_work_characteristics_and_persona_details: formData.work_characteristics.split('\n').map(s => s.trim()).filter(Boolean),
        recent_event: formData.key_event,
        feedback_goals: formData.feedback_goals.split('\n').map(s => s.trim()).filter(Boolean)
      }
    };
    
    onSubmit(customScenario);
  };

  const themeColors = getThemeColors(theme);

  const labelStyle = {
    display: 'block',
    marginBottom: 4,
    color: themeColors.text,
    fontWeight: 600,
    fontSize: 13
  };

  const sectionStyle = {
    marginBottom: 32,
    paddingBottom: 32,
  };

  const Slider = ({ label, value, onChange }) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, minWidth: 100 }}>
        <label style={{ fontSize: 13, fontWeight: 600, color: themeColors.text, textAlign: 'center' }}>
          {label}
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 100, fontSize: 10, color: themeColors.textMuted, fontWeight: 600 }}>
            <span>High</span>
            <span>Med</span>
            <span>Low</span>
          </div>
          <div style={{ width: 24, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <input
              type="range"
              min="0"
              max="2"
              value={2 - value}
              onChange={(e) => onChange(2 - Number(e.target.value))}
              onInput={(e) => onChange(2 - Number(e.target.value))}
              style={{
                width: 100,
                height: 24,
                transform: 'rotate(-90deg)',
                cursor: 'pointer',
                accentColor: BRAND.accent
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{ 
      padding: isMobile ? 12 : 28, 
      background: themeColors.background, 
      minHeight: '100vh',
      fontFamily: BRAND.font
    }}>
      <div style={{ maxWidth: 900, margin: '0 auto', width: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <button 
            onClick={onBack}
            style={{
              padding: '8px 16px',
              borderRadius: 8,
              background: themeColors.primary,
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 600
            }}
          >
            ← Back
          </button>
          <ThemeToggle />
        </div>

        <div style={{
          background: themeColors.cardBg,
          borderRadius: 10,
          padding: isMobile ? 20 : 32,
          border: `1px solid ${themeColors.borderColor}`
        }}>
          <h1 style={{ margin: '0 0 6px', fontSize: 28, color: themeColors.text, fontWeight: 700 }}>
            Create Custom Scenario
          </h1>
          <p style={{ margin: '0 0 28px', fontSize: 13, color: themeColors.textMuted }}>
            * Required fields • Lists: one item per line
          </p>

          <form onSubmit={handleSubmit}>
            {/* PERSONA DETAILS */}
            <div style={sectionStyle}>
              <h2 style={{ 
                margin: '0 0 8px', 
                fontSize: 20, 
                color: BRAND.accent, 
                fontWeight: 700,
                letterSpacing: '0.5px'
              }}>
                Persona Details
              </h2>
              <div style={{ 
                height: 4, 
                background: BRAND.accent, 
                borderRadius: 2, 
                marginBottom: 16 
              }} />

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 16, marginBottom: 12 }}>
                <div>
                  <label style={labelStyle}>Name *</label>
                  <input
                    type="text"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    style={inputStyle(themeColors)}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Position *</label>
                  <input
                    type="text"
                    required
                    value={formData.position}
                    onChange={(e) => setFormData({...formData, position: e.target.value})}
                    style={inputStyle(themeColors)}
                  />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr', gap: 16, marginBottom: 12 }}>
                <div>
                  <label style={labelStyle}>Team Name *</label>
                  <input
                    type="text"
                    required
                    value={formData.team_name}
                    onChange={(e) => setFormData({...formData, team_name: e.target.value})}
                    style={inputStyle(themeColors)}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Team Size *</label>
                  <input
                    type="text"
                    required
                    value={formData.team_size}
                    onChange={(e) => setFormData({...formData, team_size: e.target.value})}
                    style={inputStyle(themeColors)}
                  />
                </div>
              </div>

              <label style={labelStyle}>Overview *</label>
              <textarea
                required
                value={formData.overview}
                onChange={(e) => setFormData({...formData, overview: e.target.value})}
                style={{...inputStyle(themeColors), height: 90, resize: 'vertical', marginBottom: 20}}
              />

              <div style={{ 
                background: theme === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.04)',
                padding: 20,
                borderRadius: 8,
                marginBottom: 20,
                border: `1px solid ${themeColors.borderColor}`
              }}>
                <h3 style={{ margin: '0 0 16px', fontSize: 14, color: themeColors.text, fontWeight: 600 }}>
                  Personality Traits
                </h3>
                <div style={{ 
                  display: 'grid',
                  gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(140px, 1fr))',
                  gap: 16,
                  paddingTop: 8 
                }}>
                  <Slider 
                    label="Openness" 
                    value={formData.openness} 
                    onChange={(v) => setFormData({...formData, openness: v})} 
                  />
                  <Slider 
                    label="Conscientiousness" 
                    value={formData.conscientiousness} 
                    onChange={(v) => setFormData({...formData, conscientiousness: v})} 
                  />
                  <Slider 
                    label="Extraversion" 
                    value={formData.extraversion} 
                    onChange={(v) => setFormData({...formData, extraversion: v})} 
                  />
                  <Slider 
                    label="Agreeableness" 
                    value={formData.agreeableness} 
                    onChange={(v) => setFormData({...formData, agreeableness: v})} 
                  />
                  <Slider 
                    label="Regulation" 
                    value={formData.regulation} 
                    onChange={(v) => setFormData({...formData, regulation: v})} 
                  />
                </div>
              </div>

              <label style={labelStyle}>Behavioral Response Overview</label>
              <textarea
                value={formData.behavioral_overview}
                onChange={(e) => setFormData({...formData, behavioral_overview: e.target.value})}
                style={{...inputStyle(themeColors), height: 70, resize: 'vertical'}}
              />

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr', gap: 12 }}>
                <div>
                  <label style={labelStyle}>Initial Reaction</label>
                  <input
                    type="text"
                    value={formData.initial_reaction}
                    onChange={(e) => setFormData({...formData, initial_reaction: e.target.value})}
                    style={inputStyle(themeColors)}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Tendency</label>
                  <input
                    type="text"
                    value={formData.tendency}
                    onChange={(e) => setFormData({...formData, tendency: e.target.value})}
                    style={inputStyle(themeColors)}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Emotional Regulation</label>
                  <input
                    type="text"
                    value={formData.emotional_regulation}
                    onChange={(e) => setFormData({...formData, emotional_regulation: e.target.value})}
                    style={inputStyle(themeColors)}
                  />
                </div>
              </div>
            </div>

            {/* SCENARIO DETAILS */}
            <div>
              <h2 style={{ 
                margin: '0 0 8px', 
                fontSize: 20, 
                color: BRAND.accent, 
                fontWeight: 700,
                letterSpacing: '0.5px'
              }}>
                Scenario Details
              </h2>
              <div style={{ 
                height: 4, 
                background: BRAND.accent, 
                borderRadius: 2, 
                marginBottom: 16 
              }} />

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 16, marginBottom: 12 }}>
                <div>
                  <label style={labelStyle}>Scenario Name *</label>
                  <input
                    type="text"
                    required
                    value={formData.scenario_name}
                    onChange={(e) => setFormData({...formData, scenario_name: e.target.value})}
                    style={inputStyle(themeColors)}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Industry *</label>
                  <input
                    type="text"
                    required
                    value={formData.industry}
                    onChange={(e) => setFormData({...formData, industry: e.target.value})}
                    style={inputStyle(themeColors)}
                  />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr', gap: 16, marginBottom: 12 }}>
                <div>
                  <label style={labelStyle}>Company Type *</label>
                  <input
                    type="text"
                    required
                    value={formData.company_type}
                    onChange={(e) => setFormData({...formData, company_type: e.target.value})}
                    style={inputStyle(themeColors)}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Your Role *</label>
                  <input
                    type="text"
                    required
                    value={formData.manager_role}
                    onChange={(e) => setFormData({...formData, manager_role: e.target.value})}
                    style={inputStyle(themeColors)}
                  />
                </div>
              </div>

              <label style={labelStyle}>Feedback Goals (one per line) *</label>
              <textarea
                required
                value={formData.feedback_goals}
                onChange={(e) => setFormData({...formData, feedback_goals: e.target.value})}
                style={{...inputStyle(themeColors), height: 70, resize: 'vertical'}}
              />

              <label style={labelStyle}>Recent Performance (one per line) *</label>
              <textarea
                required
                value={formData.recent_performance}
                onChange={(e) => setFormData({...formData, recent_performance: e.target.value})}
                style={{...inputStyle(themeColors), height: 70, resize: 'vertical'}}
              />

              <label style={labelStyle}>Recent Events & Metrics (one per line) *</label>
              <textarea
                required
                value={formData.recent_events}
                onChange={(e) => setFormData({...formData, recent_events: e.target.value})}
                style={{...inputStyle(themeColors), height: 70, resize: 'vertical'}}
              />

              <label style={labelStyle}>Further Work Characteristics (one per line)</label>
              <textarea
                value={formData.work_characteristics}
                onChange={(e) => setFormData({...formData, work_characteristics: e.target.value})}
                style={{...inputStyle(themeColors), height: 70, resize: 'vertical'}}
              />

              <label style={labelStyle}>Key Event</label>
              <textarea
                value={formData.key_event}
                onChange={(e) => setFormData({...formData, key_event: e.target.value})}
                style={{...inputStyle(themeColors), height: 90, resize: 'vertical'}}
              />
            </div>

            <button
              type="submit"
              style={{
                padding: '14px 28px',
                borderRadius: 8,
                background: BRAND.accent,
                color: contrastText(BRAND.accent),
                border: 'none',
                cursor: 'pointer',
                fontWeight: 700,
                width: '100%',
                fontSize: 16,
                marginTop: 12
              }}
            >
              Create Custom Scenario
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}